// react-redux-firebase config
export const rrfConfig = {
    userProfile: false,
    //useFirestoreForProfile: true, // Firestore for Profile instead of Realtime DB
    //enableClaims: true, // Get custom claims along with the profile
};

export const signInURL = window.location.origin + "/completeSignIn";
